import { render, staticRenderFns } from "./PrivilegeTutorial.vue?vue&type=template&id=3a6d96a2&scoped=true&"
import script from "./PrivilegeTutorial.vue?vue&type=script&lang=js&"
export * from "./PrivilegeTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d96a2",
  null
  
)

export default component.exports